import { Box, Eye, GraduationCap, CheckCircle, Activity, Shield, Cloud, Settings, Users, Zap, ChevronRight, Menu, X, Award, Lock, Globe } from 'lucide-react';
export default function Hero() {
  return (
   <section id="hero" className="pt-32 pb-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-gray-50 to-yellow-50">
        <div className="max-w-7xl mx-auto">
          <div className="text-center max-w-4xl mx-auto mb-12">
            <div className="inline-flex items-center space-x-2 bg-yellow-100 px-4 py-2 rounded-full mb-6">
              <Award className="w-5 h-5 text-yellow-600" />
              <span className="text-sm font-semibold text-gray-800">Trusted by Fortune 500 Companies</span>
            </div>
            <h1 className="text-5xl md:text-6xl font-bold text-black mb-6 leading-tight">
              Enterprise <span className="text-[#FFC33A]">3D, AR & VR</span> Platform Suite
            </h1>
            <p className="text-xl text-gray-700 mb-8">
              Transform your sales, training, inspections, and operations with our integrated 3D visualization platform. Fully customizable, secure, and enterprise-ready.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a href="#signup" className="bg-[#FFC33A] hover:bg-yellow-500 text-black px-8 py-4 rounded-full font-semibold text-lg flex items-center justify-center space-x-2 transition shadow-lg">
                <span>Start with SalesBee</span>
                <ChevronRight className="w-5 h-5" />
              </a>
              <a href="#products" className="bg-white hover:bg-gray-50 text-black px-8 py-4 rounded-full font-semibold text-lg transition border-2 border-gray-200">
                Explore All Products
              </a>
            </div>
          </div>

          {/* Trust Indicators */}
          <div className="grid md:grid-cols-4 gap-6 max-w-5xl mx-auto">
            <div className="bg-white rounded-xl p-6 shadow-md text-center border-2 border-yellow-400/30">
              <Shield className="w-8 h-8 text-yellow-500 mx-auto mb-3" />
              <p className="text-2xl font-bold text-black mb-1">100%</p>
              <p className="text-sm text-gray-600">Secure AWS Hosting</p>
            </div>
            <div className="bg-white rounded-xl p-6 shadow-md text-center border-2 border-yellow-400/30">
              <Lock className="w-8 h-8 text-yellow-500 mx-auto mb-3" />
              <p className="text-2xl font-bold text-black mb-1">Enterprise</p>
              <p className="text-sm text-gray-600">Grade Security</p>
            </div>
            <div className="bg-white rounded-xl p-6 shadow-md text-center border-2 border-yellow-400/30">
              <Settings className="w-8 h-8 text-yellow-500 mx-auto mb-3" />
              <p className="text-2xl font-bold text-black mb-1">Fully</p>
              <p className="text-sm text-gray-600">Customizable</p>
            </div>
            <div className="bg-white rounded-xl p-6 shadow-md text-center border-2 border-yellow-400/30">
              <Globe className="w-8 h-8 text-yellow-500 mx-auto mb-3" />
              <p className="text-2xl font-bold text-black mb-1">Global</p>
              <p className="text-sm text-gray-600">Multi-Region Support</p>
            </div>
          </div>
        </div>
      </section>
  );
}
